import Vue from 'vue'
import {
  Table,
  TableColumn,
  Input,
  Form,
  FormItem,
  Select,
  Option,
  Message
} from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)

Vue.prototype.$message = Message
